import { FC } from "react";
import { useTranslation } from "react-i18next";

import Desktop from "../../../../assets/images/content/pillar-1/average-annual-additional-savings/average-annual-additional-savings-desktop.svg";
import Mobile from "../../../../assets/images/content/pillar-1/average-annual-additional-savings/average-annual-additional-savings-mobile.svg";

const AverageAnnualAdditionalSavings: FC = () => {
	const { t } = useTranslation();

	return (
		<div className="flex flex-col mt-8">
			<img
				className="hidden md:block max-w-4xl"
				src={Desktop}
				alt={t("pages.pillar.pillar1.averageAnnualAdditionalSavingsForEUHouseholds.blocks.visual.alt") as string}
				title={t("pages.pillar.pillar1.averageAnnualAdditionalSavingsForEUHouseholds.blocks.visual.alt") as string}
			/>
			<img
				className="block md:hidden"
				src={Mobile}
				alt={t("pages.pillar.pillar1.averageAnnualAdditionalSavingsForEUHouseholds.blocks.visual.alt") as string}
				title={t("pages.pillar.pillar1.averageAnnualAdditionalSavingsForEUHouseholds.blocks.visual.alt") as string}
			/>
		</div>
	);
};

export { AverageAnnualAdditionalSavings };